import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Avatar, AvatarFallback, AvatarImage } from '../components/ui/avatar';
import { api } from '../lib/api';
import { Search as SearchIcon, Users } from 'lucide-react';

export default function MemberSearch() {
  const [q, setQ] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const t = setTimeout(async () => {
      if (!q.trim()) { setResults([]); return; }
      setLoading(true);
      try {
        const { data } = await api.get(`/search/users?q=${encodeURIComponent(q)}`);
        setResults(data);
      } finally { setLoading(false); }
    }, 220);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div className="max-w-2xl mx-auto space-y-4">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold flex items-center gap-2"><Users className="w-6 h-6 text-violet-400" /> Find members</h1>
        <p className="text-sm text-slate-400">Search creators by username or name</p>
      </div>
      <div className="relative">
        <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
        <Input data-testid="member-search-input" autoFocus value={q} onChange={e => setQ(e.target.value)} placeholder="Search @username…" className="pl-9 h-12" />
      </div>
      {loading && <div className="text-sm text-slate-400 text-center py-6">Searching…</div>}
      {!loading && q && results.length === 0 && (
        <Card className="glass p-8 text-center text-sm text-slate-400">No members found for "{q}"</Card>
      )}
      <div className="space-y-2">
        {results.map(u => {
          const initials = (u.display_name || u.username || 'JX').slice(0, 2).toUpperCase();
          return (
            <Link key={u.id} to={`/profile/${u.username}`} data-testid={`search-result-${u.username}`} className="block">
              <Card className="glass p-3 flex items-center gap-3 hover:border-violet-500/50 transition-colors">
                <Avatar className="w-10 h-10 ring-1 ring-violet-500/30">
                  <AvatarImage src={u.avatar_url} />
                  <AvatarFallback className="gradient-brand text-white font-bold">{initials}</AvatarFallback>
                </Avatar>
                <div className="flex-1 min-w-0">
                  <div className="font-semibold truncate">{u.display_name || u.username}</div>
                  <div className="text-xs text-slate-400">@{u.username}</div>
                </div>
                {u.is_premium && <span className="text-[10px] px-2 py-0.5 rounded gradient-gold text-slate-950 font-bold">PREMIUM</span>}
              </Card>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
